import React, { useRef } from 'react';
import { Table } from 'antd';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './DragSortingTable.scss';

const type = 'DraggableBodyRow';

const DraggableBodyRow = ({
  index,
  moveRow,
  className,
  style,
  ...restProps
}) => {
  const ref = useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }

      return {
        isOver: monitor.isOver(),
        dropClassName:
          dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item) => {
      if (moveRow) {
        moveRow(item.index, index);
      }
    },
  });
  const [, drag] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  // Always attach refs, but only enable drag-drop visually if moveRow exists
  if (moveRow) {
    drop(drag(ref));
  }

  return (
    <tr
      ref={ref}
      className={`${className}${isOver ? dropClassName : ''}`}
      style={{ cursor: moveRow ? 'move' : 'default', ...style }}
      {...restProps}
    />
  );
};

const components = {
  body: {
    row: DraggableBodyRow,
  },
};

const DragSortingTable = ({ moveRow, ...rest }) => (
  <DndProvider backend={HTML5Backend}>
    <Table
      components={components}
      onRow={(record, index) => ({
        index,
        moveRow,
      })}
      {...rest}
    />
  </DndProvider>
);

export default DragSortingTable;
